/**
 * Report-Definition für die Team-Seite (Standalone). Spiegelt die Team-Tabelle
 * als eigenständiges PDF.
 */
import { tableBlock, type ReportBlock, type ReportDocument } from '../../../lib/pdf/reportModel';

export interface TeamReportInput {
  team: { name: string; rolle: string | null; funktion: string | null; email: string | null }[];
}

export function buildTeamReport(input: TeamReportInput): ReportDocument {
  const block: ReportBlock =
    input.team.length > 0
      ? tableBlock(
          [
            { header: 'Name', weight: 2.2 },
            { header: 'Funktion', weight: 1.8 },
            { header: 'Rolle', weight: 1.6 },
            { header: 'E-Mail', weight: 2.4 },
          ],
          input.team.map((m) => [m.name || '—', m.funktion || '—', m.rolle || '—', m.email || '—']),
        )!
      : { kind: 'note', value: 'Noch kein Team erfasst.' };

  return { sections: [{ title: 'Projekt-Team', blocks: [block] }] };
}
